import React from 'react'
import Stepper from '../ui/Stepper'
import SocialProof from '../ui/SocialProof'
import JourneyProgress from '../ui/JourneyProgress'
import styles from './styles.module.scss'

interface FormTemplateProps {
    heading: string
    title?: string
    children: React.ReactNode
    progress?: number
    currentStep?: 1 | 2 | 3
    hideSteps?: boolean
    // Drops the "featured in" news logos, e.g. once they're in the claim form
    hideSocialProof?: boolean
}

const FormTemplate: React.FC<FormTemplateProps> = ({
    heading,
    title,
    children,
    progress,
    currentStep = 1,
    hideSteps = false,
    hideSocialProof = false,
}) => {
    return (
        <div className={styles.flowContainer}>
            <div className={styles.stepCard}>
                {!hideSteps && currentStep && <Stepper currentStep={currentStep} />}
                {progress !== undefined && <JourneyProgress percent={progress} className={styles.progress} />}
                {title && (
                    <div className={styles.headerRow}>
                        <span className={styles.titleText}>{title}</span>
                        {/* <h1>{heading}</h1> */}
                    </div>
                )}
                {children}
            </div>
            {!hideSocialProof && (
                <div className={styles.socialProofSection}>
                    <SocialProof title="Sentinel Legal has featured in" />
                </div>
            )}
            <div className={styles.stepIndicator}>
                Authorised and regulated by the Solicitors Regulation Authority. SRA number 811792. Company number
                12826774. VAT registration number 423 9685 69.
            </div>
        </div>
    )
}

export default FormTemplate
